import * as React from 'react';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';

export default function PieActiveArc({data, onClickId, legendHidden}) {
    const [identifier, setIdentifier] = React.useState(null);
    const [id, setId] = React.useState(undefined);
  
    const handleClick = (event, itemIdentifier, item) => {
      setId(item.id);
      setIdentifier(itemIdentifier);
      onClickId(item.id)
    };

  return (
    <PieChart
     margin={{ top: 10, bottom: 10, left: 10, right:10 }}
      series={[
        {
          data,
        },
      ]}
      slotProps={{
        legend: {
            direction: "column",
            itemMarkWidth: 8,
            itemMarkHeight: 8,
            markGap: 10,
            itemGap: 10,
            hidden: legendHidden, 
            position: { vertical: 'bottom', horizontal: 'left' },
            labelStyle: {
            fontSize: 13,
          },
        },
      }}

      onClick={handleClick}
      
      height={200}
    />
  );
}